import singleton from "./singleton";
import requestSingleton from "./request-singleton";

export default global.window != null ? singleton : requestSingleton;
